class NewsletterNudge extends HTMLElement {
    constructor() {
        super();

        this.show()
        this.close();
    }

    show(){
        let cookie = document.cookie.match(/^(.*;)?\s*newsletter-nudge\s*=\s*[^;]+(.*)?$/);

        if(!cookie){
            this.classList.remove('hidden');
        }
    }

    close(){
        let closeButton = this.querySelector('.newsletter-nudge__close');

        closeButton.addEventListener('click', () => {
            this.classList.add('hidden');
            this.addCookie()
        })
    }
    
    addCookie(){
        const d = new Date();
        d.setTime(d.getTime() + (1*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = 'newsletter-nudge' + "=" + true + ";" + expires + ";path=/";
    }

    
}
  
customElements.define('newsletter-nudge', NewsletterNudge);